import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import CommentItem from './CommentItem';

function CommentList({
    comments,
    isLogined,
    userInfo,
    highlightId,
    highlightReplyId,
    onOpenReply,
    onDeleteComment,
    onDeleteReply,
    newReply,
    setReply,
    onNewReply,
}) {
    if (comments.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center gap-2 py-10 text-content-3">
                <FontAwesomeIcon icon={faComments} className="text-3xl" />
                <p className="text-sm">Chưa có bình luận — hãy là người đầu tiên!</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-1">
            {comments.map((comment) => (
                <CommentItem
                    key={comment.commentId}
                    comment={comment}
                    isLogined={isLogined}
                    userInfo={userInfo}
                    isHighlighted={highlightId === String(comment.commentId)}
                    highlightReplyId={highlightReplyId}
                    onOpenReply={onOpenReply}
                    onDeleteComment={onDeleteComment}
                    onDeleteReply={onDeleteReply}
                    newReply={newReply}
                    setReply={setReply}
                    onSubmitReply={() => onNewReply(comment.commentId)}
                />
            ))}
        </div>
    );
}

export default CommentList;
